<template>
  <div
    class="wrapper pa-4"
  >
    <h1>摄像机 改变镜头视角</h1>
    <p>
      <canvas
        id="c3"
        style="border: 1px solid;width: 100%;"
      />
    </p>
    <!-- eslint-disable-next-line -->
    <p><div id="gui" style="position: relative;;"></div></p>
    <p>
      添加旋转镜头
      <highlightjs
        :code="`import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';

//.. init函数添加:
const controls = new OrbitControls( this.camera, canvas );
// target
controls.target.set( 0, 0, 0 );
controls.update();`"
        :language="'js'"
      />
    </p>
    <p>
      再添加GUI控制面板
      <highlightjs
        :code="`import { GUI } from 'three/examples/jsm/libs/lil-gui.module.min.js';

//.. init函数添加:
class MinMaxGUIHelper {

  constructor( obj, minProp, maxProp, minDif ) {

    this.obj = obj;
    this.minProp = minProp;
    this.maxProp = maxProp;
    this.minDif = minDif;

  }
  get min() {

    return this.obj[ this.minProp ];

  }
  set min( v ) {

    this.obj[ this.minProp ] = v;
    this.obj[ this.maxProp ] = Math.max( this.obj[ this.maxProp ], v + this.minDif );

  }
  get max() {

    return this.obj[ this.maxProp ];

  }
  set max( v ) {

    this.obj[ this.maxProp ] = v;
    // eslint-disable-next-line
    this.min = this.min; // this will call the min setter

  }

}
// GUI
const gui = new GUI();
gui.add( this.camera, 'fov', 1, 180 ).onChange( this.updateCamera );
const minMaxGUIHelper = new MinMaxGUIHelper( this.camera, 'near', 'far', 0.1 );
gui.add( minMaxGUIHelper, 'min', 0.1, 50, 0.1 ).name( 'near' ).onChange( this.updateCamera );
gui.add( minMaxGUIHelper, 'max', 0.1, 50, 0.1 ).name( 'far' ).onChange( this.updateCamera );
// position
gui.add( this.camera.position, 'x', -10, 10 ).name( 'cameraX' );
gui.add( this.camera.position, 'y', -10, 10 ).name( 'cameraY' );
gui.add( this.camera.position, 'z', -10, 10 ).name( 'cameraZ' );`"
        :language="'js'"
      />
    </p>
    <p>
      <highlightjs
        :code="`// gui 元素移动到 #gui 下面
const guiElement = document.querySelector('#gui');
guiElement.appendChild(gui.domElement);
gui.domElement.style.position = 'absolute';
// zindex防止覆盖到左侧菜单
guiElement.style.zIndex = '1';
guiElement.style.height = '200px';`"
        :language="'js'"
      />
    </p>
    <p>
      添加地面mesh
      <highlightjs
        :code="`{
  const planeSize = 10;
  const loader = new THREE.TextureLoader();
  const texture = loader.load( 'https://threejs.org/manual/examples/resources/images/checker.png' );
  texture.wrapS = THREE.RepeatWrapping;
  texture.wrapT = THREE.RepeatWrapping;
  texture.magFilter = THREE.NearestFilter;
  //texture.colorSpace = THREE.SRGBColorSpace;
  const repeats = planeSize / 2;
  texture.repeat.set( repeats, repeats );

  const planeGeo = new THREE.PlaneGeometry( planeSize, planeSize );
  const planeMat = new THREE.MeshPhongMaterial( {
    map: texture,
    side: THREE.DoubleSide,
  } );
  const mesh = new THREE.Mesh( planeGeo, planeMat );
  mesh.rotation.x = Math.PI * - .5;
  this.scene.add( mesh );
}`"
        :language="'js'"
      />
    </p>
    <p>
      <a href="https://threejs.org/manual/#zh/cameras">https://threejs.org/manual/#zh/cameras</a>
    </p>
  </div>
</template>

<script>
import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { GUI } from 'three/examples/jsm/libs/lil-gui.module.min.js';

// eslint-disable-next-line
const loader = new GLTFLoader();

export default {
  data() {
    return {
      state3: {
        time: 0,
      },
      renderer3: null,
      scene: null,
      camera: null,
      cube: null,
    };
  },
  mounted() {
    this.init3();

    this.animate3();
    requestAnimationFrame(this.animate3);
  },
  // 组件销毁
  beforeDestroy() {
    console.log('beforeDestroy threejs7');
    // 销毁
    // ???
    this.renderer.dispose();
  },
  methods: {
    init3() {
      // canvas
      const canvas = document.querySelector('#c3');
      // 渲染器 antialias代表是否开启抗锯齿
      this.renderer = new THREE.WebGLRenderer({antialias: true, canvas});
      this.camera = new THREE.PerspectiveCamera(100, 2, 0.1, 80);

      // 摄像机位置
      // 摄像机位置 xyz
      this.camera.position.set( -1, 0.5, 3);
      // this.camera.lookAt( 0, 0, 0 );
      // this.camera.position.x = -1;
      // this.camera.position.y = 0.5;
      // this.camera.position.z = 3;


      class MinMaxGUIHelper {

        constructor( obj, minProp, maxProp, minDif ) {

          this.obj = obj;
          this.minProp = minProp;
          this.maxProp = maxProp;
          this.minDif = minDif;

        }
        get min() {

          return this.obj[ this.minProp ];

        }
        set min( v ) {

          this.obj[ this.minProp ] = v;
          this.obj[ this.maxProp ] = Math.max( this.obj[ this.maxProp ], v + this.minDif );

        }
        get max() {

          return this.obj[ this.maxProp ];

        }
        set max( v ) {

          this.obj[ this.maxProp ] = v;
          // eslint-disable-next-line
          this.min = this.min; // this will call the min setter

        }

      }
      // GUI
      const gui = new GUI();
      gui.add( this.camera, 'fov', 1, 180 ).onChange( this.updateCamera );
      const minMaxGUIHelper = new MinMaxGUIHelper( this.camera, 'near', 'far', 0.1 );
      gui.add( minMaxGUIHelper, 'min', 0.1, 50, 0.1 ).name( 'near' ).onChange( this.updateCamera );
      gui.add( minMaxGUIHelper, 'max', 0.1, 50, 0.1 ).name( 'far' ).onChange( this.updateCamera );
      gui.add( this.camera.position, 'x', -10, 10 ).name( 'cameraX' );
      gui.add( this.camera.position, 'y', -10, 10 ).name( 'cameraY' );
      gui.add( this.camera.position, 'z', -10, 10 ).name( 'cameraZ' );
      // gui 元素移动到 #gui 下面
      const guiElement = document.querySelector('#gui');
      guiElement.appendChild(gui.domElement);
      gui.domElement.style.position = 'absolute';
      // zindex防止覆盖到左侧菜单
      guiElement.style.zIndex = '1';
      guiElement.style.height = '200px';
      

      const controls = new OrbitControls( this.camera, canvas );
      // target
      controls.target.set( 0, 0, 0 );
      controls.update();
      
      // 创建场景
      this.scene = new THREE.Scene();
      this.scene.background = new THREE.Color( 'black' );


      {
        const planeSize = 10;
        const loader = new THREE.TextureLoader();
        const texture = loader.load( 'https://threejs.org/manual/examples/resources/images/checker.png' );
        texture.wrapS = THREE.RepeatWrapping;
        texture.wrapT = THREE.RepeatWrapping;
        texture.magFilter = THREE.NearestFilter;
        //texture.colorSpace = THREE.SRGBColorSpace;
        const repeats = planeSize / 2;
        texture.repeat.set( repeats, repeats );

        const planeGeo = new THREE.PlaneGeometry( planeSize, planeSize );
        const planeMat = new THREE.MeshPhongMaterial( {
          map: texture,
          side: THREE.DoubleSide,
        } );
        const mesh = new THREE.Mesh( planeGeo, planeMat );
        mesh.rotation.x = Math.PI * - .5;
        this.scene.add( mesh );

      }

      // 场景+方块
      const geometry = new THREE.BoxGeometry(1, 1, 1);
      const material = new THREE.MeshPhongMaterial({
        color: '#FFDD11',
      });
      this.cube = new THREE.Mesh(geometry, material);
      this.cube.position.set( 10, 0, 0 );
      this.scene.add(this.cube);

      // 场景+glb对象
      const scene = this.scene;
      loader.load('stone.glb', function ( gltf ) {
        // 添加网格对象到场景
        scene.add( gltf.scene );
      }, undefined, function ( error ) {
        console.error( error );
      } );

      // 场景+灯光
      const color = 0xFFFFFF;
      const intensity = 3;
      const light = new THREE.DirectionalLight(color, intensity);
      light.position.set(-1, 2, 4); // 位置
      this.scene.add(light);

      // 之后将场景和摄像机传递给渲染器来渲染出整个场景。
      this.renderer.render(this.scene, this.camera);
    },
    updateCamera() {
      this.camera.updateProjectionMatrix();
    },

    // 判断画布是否需要调整大小
    resizeRendererToDisplaySize(renderer) {
      const canvas = renderer.domElement;
      const width = canvas.clientWidth;
      const height = canvas.clientHeight;
      const needResize = canvas.width !== width || canvas.height !== height;
      if (needResize) {
        renderer.setSize(width, height, false);
      }
      return needResize;
    },
    render3() {
      // 注意如果我们的canvas大小被调整了那函数会返回true。我们可以利用 这个来检查是否有其他的东西应该更新。我们修改渲染循环 来使用我们的新函数
      if (this.resizeRendererToDisplaySize(this.renderer)) {
        const canvas = this.renderer.domElement;
        this.camera.aspect = canvas.clientWidth / canvas.clientHeight;
        this.camera.updateProjectionMatrix();
      }

      // 旋转方块
      const speed = 0.1;
      const rot = this.state3.time * speed;
      this.cube.rotation.x = rot;
      this.cube.rotation.y = rot;

      this.renderer.render(this.scene, this.camera);

      requestAnimationFrame(this.render3);
    },
    animate3(time) {
      this.state3.time = time * 0.01;
      this.render3();
    
    },
  }
}
</script>

<style scoped>
.wrapper {
  display: grid;
  grid-template-columns:
    1fr
    min(65ch, 100%)
    1fr;
}

.wrapper > * {
  grid-column: 2;
}

.full-bleed {
  width: 100%;
  grid-column: 1 / -1;
}

/* 移动端换行 */
a {
  word-break: break-all;
}

</style>